/**
 * Shared filter-match shape used by Sidebar tabs (Files, Topics, Events) to
 * indicate the highlighted slice of a string returned by a filter operation.
 */
export interface FilterMatch {
  /** The start (inclusive) and end (exclusive) index of the match within the text. */
  position: [number, number];
}

/**
 * Defensive guard at the slicing boundary: malformed positions (negative,
 * past the end, or `to < from`) would silently produce wrong output via
 * `String.prototype.slice`. Clamp into `[0, length]` with `from <= to` so
 * consumers can't misrepresent the text even when the matcher contract is
 * violated upstream.
 */
export function clampMatchPosition(
  position: readonly [number, number],
  length: number,
): [number, number] {
  const from = Math.max(0, Math.min(position[0], length));
  const to = Math.max(from, Math.min(position[1], length));
  return [from, to];
}
